import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon';

export default function MouseControls(props:any) {
  return (
    <SvgIcon viewBox='0 0 17 23' { ...props}>
      <path d="M7.77832 0.405762C3.82832 0.895762 0.77832 4.25576 0.77832 8.33576H7.77832V0.405762ZM0.77832 14.3358C0.77832 16.4575 1.62118 18.4923 3.12147 19.9926C4.62176 21.4929 6.65659 22.3358 8.77832 22.3358C10.9001 22.3358 12.9349 21.4929 14.4352 19.9926C15.9355 18.4923 16.7783 16.4575 16.7783 14.3358V10.3358H0.77832V14.3358ZM9.77832 0.405762V8.33576H16.7783C16.7783 4.25576 13.7183 0.895762 9.77832 0.405762Z" fill="currentColor"/>
    </SvgIcon>
  );
}